'use strict';

const shouldRedirectToFbaMenu = (urlParams = {}) => {
    const {avoidRedirect} = urlParams;
    const isNewCancellationFlow =
        urlParams.funnel === 'cancellationHSA' && Odigeo.AB.isHsaNewCancellationFlowEnabled;

    return !isNewCancellationFlow && Odigeo.AB.isFbaMmbMenu && !avoidRedirect;
};

const buildFbaMenuHandoffSegment = (flagName, value) =>
    value === 'true' || value === true ? `${flagName}=true` : '';

const buildFbaMenuRoute = (tdToken, autoChange, autoCancel) => {
    const handoffFlags = [
        buildFbaMenuHandoffSegment('autoChange', autoChange),
        buildFbaMenuHandoffSegment('autoCancel', autoCancel),
    ].filter(Boolean).join('/');

    return `menu/${handoffFlags ? `${handoffFlags}/` : ''}${tdToken}/`;
};

module.exports = {
    shouldRedirectToFbaMenu,
    buildFbaMenuHandoffSegment,
    buildFbaMenuRoute,
};
